import { useTheme } from '@emotion/react';
import { BlockstarActionType, ThemeType } from '@shared-data';
import React from 'react';
import { Dropdown } from 'src/components/library/dropdown';
import { ProgressBar } from 'src/components/library/progress-bar';
import { Skill } from 'src/components/library/skill-details/skill';
import { calculateProgress } from 'src/utils/utils';
import {
  DropdownSkillXPBar,
  DropdownSkillXPContainer,
  DropdownSkillXPText,
} from '../../style';
import { IActionSkillsData } from './skill-dropdown';
import { DropdownItem } from './style';

const BlockstarSkillDropdown = (props: {
  disabled: boolean;
  skills: IActionSkillsData[];
  selectedSkill: number;
  actionType: BlockstarActionType;
  onSkillSelected: (index: number) => void;
}) => {
  const theme = useTheme() as ThemeType;

  const onChange = (index: number) => {
    props.onSkillSelected(index);
  };

  return (
    <Dropdown
      disabled={props.disabled}
      value={
        props.selectedSkill < props.skills.length
          ? props.selectedSkill
          : props.skills.length - 1
      }
      onChange={onChange}
      style={{
        pointerEvents:
          props.actionType === BlockstarActionType.Busking ? 'none' : 'auto',
        width: '85%',
      }}
      components={props.skills.map((val, idx) => {
        return {
          component: (
            <DropdownSkill
              skill={val}
              color={theme.colors.ui.specialPink}
              actionType={props.actionType}
            />
          ),
          disabled: !val.title,
        };
      })}
    />
  );
};

const DropdownSkill = (props: {
  skill: IActionSkillsData;
  color: string;
  actionType: BlockstarActionType;
}) => {
  const level = props.skill.maxed
    ? 100
    : calculateProgress(props.skill.currentExp, props.skill.targetExp, true);
  const locked = !props.skill.title;
  const title = locked ? 'Skill not available yet' : props.skill.title;
  return (
    <DropdownItem>
      <div style={{ display: 'flex', flex: 1, width: '100%' }}>
        <Skill
          type={props.skill.type}
          title={title}
          width={!locked ? 96 : undefined}
        />
      </div>
      {!locked && props.actionType !== BlockstarActionType.Busking && (
        <DropdownSkillXPContainer>
          <DropdownSkillXPText>
            {props.skill.maxed ? (
              <span>Full potential reached!</span>
            ) : (
              <span>
                {Math.floor(props.skill.currentExp).toLocaleString()}/
                {props.skill.targetExp.toLocaleString()} XP
              </span>
            )}
          </DropdownSkillXPText>
          <DropdownSkillXPBar>
            <ProgressBar currentLevel={level} color={props.color} />
          </DropdownSkillXPBar>
        </DropdownSkillXPContainer>
      )}
    </DropdownItem>
  );
};

export default BlockstarSkillDropdown;
